import React, { useRef, useState } from 'react';
import AuthFormContainer from './AuthFormContainer';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import { useAuth } from './../../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import './../../PAT.css';

function Login(props) {
    const emailRef = useRef();
    const passwordRef = useRef();
    const { loginWithEmailAndPassword, currentUser } = useAuth();
    const [ error, setError ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const navigate = useNavigate();

    function validateEmail(email) {
        if (props.specificEmail) {
            const emails = props.specificEmails.split(',');
            for (let i = 0; i < emails.length; i++) {
                if (emails[i].trim().toLowerCase() === email.trim().toLowerCase()) {
                    return true;
                }
            }
        }
        return true;
    }

    async function handleSubmit(e) {
        // Prevent our form from refreshing.
        e.preventDefault();

        let succeeded = false;

        if (props.specificEmail && validateEmail(emailRef.current.value)) { // props.specificEmail !== emailRef.current.value) {
            setError('This account is not authorized.');
            return;
        }

        try {
            setError('');
            setLoading(true);

            const userCredential = await loginWithEmailAndPassword(emailRef.current.value, passwordRef.current.value);

            console.log(`userCredential = ${JSON.stringify(userCredential)}`);

            succeeded = true;

            setLoading(false);

            // Send error: empty string to indicate that it's a success.
            sendLoginResult('');
    
            // Go to Dashboard page.
            //navigate("/");
        }
        catch(e) {
            setError('Failed to sign in. Error: ' + JSON.stringify(e));

            if (e.code === "auth/user-not-found") {
                setError('User not found.');
            }
            else if (e.code === "auth/wrong-password") {
                setError('Wrong password.');
            }
            else {
                setError('Failed to sign in. Error: ' + JSON.stringify(e));
            }

            setLoading(false);

            // Do not send failure result, and let the user tries again. Or, the process will stop.
            // Send error string to indicate that it's a failure.
            //sendLoginResult(error);
        }


        /*
        setError('');
        setLoading(true);

        loginWithEmailAndPassword(emailRef.current.value, passwordRef.current.value)
        .then((userCredential) => {
            //console.log(`userCredential = ${JSON.stringify(userCredential)}`);

            succeeded = true;

            setLoading(false);
    
            sendLoginResult(succeeded ? '' : error);
        })
        .catch((error) => {
            setError('Failed to sign in. Error: ' + JSON.stringify(error));

            if (error.code === "auth/user-not-found") {
                setError('User not found.');
            }
            else if (error.code === "auth/wrong-password") {
                setError('Wrong password.');
            }
            else {
                setError('Failed to sign in. Error: ' + JSON.stringify(error));
            }
        });
        */
    }

    function sendLoginResult(error) {
        if (props.onLoggedIn) {
            props.onLoggedIn(error);
        }
    }

    function renderSignUpLink() {
        if (props.hideSignUpLink) {
            return null;
        }

        if (props.onClickSignupFromLogin) {
            return (<span className='AuthPageLink' onClick={onClickSignup}><i class="fas fa-user-plus ms-2 me-1"></i>Sign Up</span>);
        }
        
        return (<Link to="/signup"><i class="fas fa-user-plus ms-2 me-1"></i>Sign Up</Link>);
    }

    function onClickSignup(e) {
        if (props.onClickSignupFromLogin) {
            props.onClickSignupFromLogin();
        }
    }

    function renderForgotPasswordLink() {
        if (props.hideForgotPasswordLink) {
            return null;
        }

        if (props.onClickForgotPassword) {
            return (<span className='AuthPageLink' onClick={(e) => props.onClickForgotPassword()}><i class="fas fa-question-circle me-2" />Forgot Password ?</span>);
        }

        return (<Link to="/forgot-password"><i class="fas fa-question-circle me-2" />Forgot Password ?</Link>);
    }

    return (
        <>
            <AuthFormContainer>
                <Card className='MtlLogin'>
                    <Card.Body>
                        <h3 class="h-style-2 TextPrimary text-center">LOG IN</h3>
                        { error ? <Alert variant="danger">{error}</Alert> : null }
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" id="email" style={{textAlign:'left'}}>
                                <Form.Label className='AuthFormText AuthFormLabel ms-2'>Email</Form.Label>
                                <div>
                                    <input className='AuthFormControl AuthFormText' type="email" ref={emailRef} required aria-describedby="emailHelp" placeholder="กรุณากรอกอีเมล" />
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3" id="password" style={{textAlign:'left'}}>
                                <Form.Label className='AuthFormText AuthFormLabel ms-2'>Password</Form.Label>
                                <div>
                                    <input className='AuthFormControl AuthFormText' type="password" ref={passwordRef} required placeholder="กรุณากรอกรหัสผ่าน" />
                                </div>
                            </Form.Group>
                            <button disable={loading.toString()} class="Btn BtnMtpPrimary BtnLogin w-100" type="submit"><i class="fas fa-sign-in-alt"></i> Log In</button>
                            <div className="w-100 text-center mt-3 AuthFormText">
                                { renderForgotPasswordLink() }
                            </div>
                            <div className="w-100 text-center mt-2 AuthFormText">
                                { props.hideSignUpLink ? null : <b>Need an account?</b> } { renderSignUpLink() }
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </AuthFormContainer>
        </>
    );
}

export default Login;
